import Edit from '../../../base/forms/user/Edit';

const edit: Edit = {
  header: 'Edit user',
  submit: 'Edit'
};

export default edit;
